import style from './style.scss';

/**
 * The CheckboxIcon component renders a checkbox icon, either checked or unchecked.
 *
 * props:
 * - checked: true is the checkbox is checked, false if unchecked
 * - fill: fill colour for the checkbox
 */
const CheckboxIcon = props => {

	const inlineStyles = {};

	if (props.fill) {
		inlineStyles.fill = props.fill;
	}

	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class={style.checkbox} style={inlineStyles}>
			{
				props.checked
					? [
						<path d="M0 0h24v24H0z" fill="none" />,
						<path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
					]
					: [
						<path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />,
						<path d="M0 0h24v24H0z" fill="none" />
					]
			}
		</svg>
	);

};

export default CheckboxIcon;



// WEBPACK FOOTER //
// ./components/icons/checkbox.js